import { render } from "./navbar_web.vue?vue&type=template&id=15992216&scoped=true"
import script from "./navbar_web.vue?vue&type=script&lang=js"
export * from "./navbar_web.vue?vue&type=script&lang=js"

import "./navbar_web.vue?vue&type=style&index=0&id=15992216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15992216"]])

export default __exports__